import getCorrespondingDuration from 'core/services/getPlansByProductId/getCorrespondingDuration'
import { DurationResponse, recEngineParseDuration } from 'utils/pivot/recEngineParser'
import { propAccessor } from '@hc-frontend/utils'

function parseFeaturedPlans({ store }): { [key: string]: DurationResponse } {
  const recommendedData = store.recEngine
  const response = {}

  Object.keys(recommendedData).forEach(key => {
    if (key !== 'default') {
      const tuple = key.split('x')

      const policy = tuple[1] ? tuple[0] : 1
      const parsedPeriod = tuple[1] || tuple[0]
      if (+parsedPeriod === store.period) {
        const durationResponse: DurationResponse = {
          duration: +parsedPeriod,
          policies: +policy,
          extension: 0,
          original: key
        }

        recommendedData[key].forEach(planId => {
          const currentDuration = response[planId]
          response[planId] =
            currentDuration && currentDuration.policies > policy
              ? currentDuration
              : durationResponse
        })
      }
    }
  })

  const recommendedDefault = propAccessor(recommendedData, 'default', [])
  recommendedDefault.forEach(data => {
    const [planId, tuple] = data.split(':')
    const currentDuration = response[planId]

    if (tuple) {
      if (tuple.includes(store.period)) {
        const parsedDuration = recEngineParseDuration(tuple)
        response[planId] =
          currentDuration && currentDuration.policies > parsedDuration.policies
            ? currentDuration
            : parsedDuration
      }
    } else if (!currentDuration) {
      const plan = store.plans[planId]
      if (plan) {
        const planDuration = getCorrespondingDuration({
          plan,
          mainPeriod: store.period,
          additionalPeriods: store.additionalPeriods
        })

        if (planDuration) {
          const policies = Object.keys(planDuration)
          const maxPolicy = policies[policies.length - 1]
          const policy = planDuration[maxPolicy]

          const durationResponse: DurationResponse = {
            duration: +policy.policyDuration,
            policies: +policy.recurrence,
            original: store.period,
            extension: 0
          }

          response[planId] = durationResponse
        }
      }
    }
  })
  return response
}

export default parseFeaturedPlans
